// @flow

import * as React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import Tile from "../molecules/Tile";
import addACFData from "../../utils/addACFData";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";
import SectionHeader from "../molecules/SectionHeader";

type PropsType = {
    tiles: any[],
    description?: string,
    title?: string,
    tileSize: string,
    noHeader: boolean,
    noDescription?: boolean,
    tileVariation?: "lg" | "md" | "sm",
    mobileScrollable?: boolean,
    className?: string,
};

const TileRow = (props: PropsType): React.Node => {
    const classList = ["tile-row"];
    if (props.className) {
        classList.push(props.className);
    }

    if (props.mobileScrollable) {
        classList.push("tile-row--mobile-scrollable");
    }

    return (
        <div className={classList.join(" ")}>
            {props.noHeader ? null : (
                <SectionHeader
                    sectionName="tile-row"
                    title={props.title}
                    description={props.description}
                />
            )}
            {props.mobileScrollable ? (
                <ScrollContainer
                    className="tile-row__scroller"
                    hideScrollbars={true}
                    vertical={false}
                    // onScroll={updateScrollNavigation}
                    // innerRef={scrollRef}
                >
                    <div className="tile-row__inner row">
                        {props.tiles &&
                            props.tiles.map((tile, tileIndex): React.Node => {
                                const referenceContent = tile.acf
                                    ? getContentReferenceTileProps(tile)
                                    : tile.tile_reference
                                    ? getContentReferenceTileProps(
                                          addACFData(tile.tile_reference)
                                      )
                                    : null;
                                const manualContent =
                                    tile.manual_content && tile.tile_content
                                        ? tile.tile_content
                                        : null;

                                if (manualContent || referenceContent) {
                                    return (
                                        <div
                                            key={tileIndex}
                                            className={props.tileSize}
                                        >
                                            <Tile
                                                {...(manualContent ||
                                                    referenceContent)}
                                                size={props.tileVariation}
                                                noDescription={
                                                    props.noDescription
                                                }
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                    </div>
                </ScrollContainer>
            ) : (
                <div className="tile-row__inner row">
                    {props.tiles &&
                        props.tiles.map((tile, tileIndex): React.Node => {
                            const referenceContent = tile.acf
                                ? getContentReferenceTileProps(tile)
                                : tile.tile_reference
                                ? getContentReferenceTileProps(
                                      addACFData(tile.tile_reference)
                                  )
                                : null;
                            const manualContent =
                                tile.manual_content && tile.tile_content
                                    ? tile.tile_content
                                    : null;

                            if (manualContent || referenceContent) {
                                return (
                                    <div
                                        key={tileIndex}
                                        className={props.tileSize}
                                    >
                                        <Tile
                                            {...(manualContent ||
                                                referenceContent)}
                                            size={props.tileVariation}
                                            noDescription={props.noDescription}
                                        />
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                </div>
            )}
        </div>
    );
};

TileRow.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
    tileSize: "col-xs-6 col-md-4",
    noHeader: false,
};

export default TileRow;
